<template>
  <div id="app">
    <Header v-if="show" />
    <!-- <Questionnair /> -->
    <router-view />
    <Footer class="footercss" v-if="this.$route.name != 'GIS'" />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
//import Questionnair from "@/components/Questionnair.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer,
    //Questionnair,
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    refresh() {
      this.show = false;
      this.$nextTick().then(() => {
        this.show = true;
      });
    },
  },
  watch: {
    "$route.name"(val) {
      if (val == "GIS") {
        this.$nextTick().then(() => {
          this.$forceUpdate();
        });
      }
    },
  },
};
</script>

<style scoped>
.footercss {
  width: 100%;
}
.apexcharts-tooltip {
  opacity: 1 !important;
}
</style>
